module.exports = __webpack_public_path__ + "static/img/0542_1.96600f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0542_1.jpg
// module id = 9La+
// module chunks = 1